var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":"Depot","items":_vm.depots,"item-value":"id","item-text":"name","rules":[_vm.validate]},on:{"change":_vm.handleChange},model:{value:(_vm.depotId),callback:function ($$v) {_vm.depotId=$$v},expression:"depotId"}})}
var staticRenderFns = []

export { render, staticRenderFns }